import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Reducer } from 'redux';
import { PersistPartial } from 'redux-persist/es/persistReducer';
import { put, takeLatest, call } from 'redux-saga/effects';

import { TAppActions } from '../rootDuck';

import { ActionsUnion, createAction } from '../../utils/action-helper';
import { IServerResponse } from '../../interfaces/server';
import {
  getUsersByRole,
  createUser,
  editUser,
  getUser,
  sendInvite,
  deleteUser,
  uploadUserAvatar,
  createLink,
} from '../../crud/users.crud';
import { IUserList, IUserAddProps, IUserEditProps, TUserAttr, IUser } from '../../interfaces/user';
import { getResponseMessage } from '../../utils/utils';
import { TUserParamsSearch } from '../../components/ui/UsersFilter/types';

const CLEAR_FETCH = 'users/CLEAR_FETCH';
const FETCH_REQUEST = 'users/FETCH_REQUEST';
const FETCH_SUCCESS = 'users/FETCH_SUCCESS';
const FETCH_FAIL = 'users/FETCH_FAIL';

const CLEAR_FETCH_BY_ID = 'users/CLEAR_FETCH_BY_ID';
const FETCH_BY_ID_REQUEST = 'users/FETCH_BY_ID_REQUEST';
const FETCH_BY_ID_SUCCESS = 'users/FETCH_BY_ID_SUCCESS';
const FETCH_BY_ID_FAIL = 'users/FETCH_BY_ID_FAIL';
const SET_USERS = 'users/SET_USERS';

const CLEAR_ADD = 'users/CLEAR_ADD'
const CLEAR_EDIT = 'users/CLEAR_EDIT';
const ADD_REQUEST = 'users/ADD_REQUEST';
const EDIT_REQUEST = 'users/EDIT_REQUEST';
const EDIT_SUCCESS = 'users/EDIT_SUCCESS';
const EDIT_FAIL = 'users/EDIT_FAIL';

const CLEAR_SEND_INVITE = 'users/CLEAR_SEND_INVITE';
const SEND_INVITE_REQUEST = 'users/SEND_INVITE_REQUEST';
const SEND_INVITE_SUCCESS = 'users/SEND_INVITE_SUCCESS';
const SEND_INVITE_FAIL = 'users/SEND_INVITE_FAIL';

const CLEAR_DEL_USER = 'users/CLEAR_DEL_USER';
const DEL_USER_REQUEST = 'users/DEL_USER_REQUEST';
const DEL_USER_SUCCESS = 'users/DEL_USER_SUCCESS';
const DEL_USER_FAIL = 'users/DEL_USER_FAIL';

const SET_USERATTR = 'users/SET_USERATTR';

const SET_FILTER = 'users/SET_FILTER';

const UPLOAD_AVATAR_REQUEST = 'users/UPLOAD_AVATAR_REQUEST';
const UPLOAD_AVATAR_SUCCESS = 'users/UPLOAD_AVATAR_SUCCESS';
const UPLOAD_AVATAR_FAIL = 'users/UPLOAD_AVATAR_FAIL';
const CLEAR_PAGINATION = 'users/CLEAR_PAGINATION';
const ADD_SUCCESS = 'users/ADD_SUCCESS';
const CLEAR_ADD_USER_ID = 'users/CLEAR_ADD_USER_ID';

const CLEAR_LINK = 'users/CLEAR_LINK';
const CREATE_LINK_REQUEST = 'users/CREATE_LINK_REQUEST';
const CREATE_LINK_SUCCESS = 'users/CREATE_LINK_SUCCESS';
const CREATE_LINK_FAIL = 'users/CREATE_LINK_FAIL';

export interface IInitialState {
  page: number;
  size: number;
  total: number;
  users: IUserList | null;
  loading: boolean;
  success: boolean;
  error: string | null;

  userId: string | null

  user: IUser | null;
  byIdLoading: boolean;
  byIdSuccess: boolean;
  byIdError: string | null;

  editLoading: boolean;
  editSuccess: boolean;
  editError: string | null;

  sendInviteLoading: boolean;
  sendInviteSuccess: boolean;
  sendInviteError: string | null;

  delUserLoading: boolean;
  delUserSuccess: boolean;
  delUserError: string | null;

  userAttr: null | TUserAttr;

  filter: { [key: string]: string[] };

  uploadAvatarLoading: boolean;
  uploadAvatarSuccess: boolean;
  uploadAvatarError: string | null;
  addSuccess: boolean;
  addUserId: number | undefined;

  linkCode: string | null
  linkLoading: boolean;
  linkSuccess: boolean;
  linkError: string | null;
}

const initialState: IInitialState = {
  page: 0,
  size: 20,
  total: 0,
  users: null,
  loading: false,
  success: false,
  error: null,

  userId: null,

  user: null,
  byIdLoading: false,
  byIdSuccess: false,
  byIdError: null,

  editLoading: false,
  editSuccess: false,
  editError: null,

  sendInviteLoading: false,
  sendInviteSuccess: false,
  sendInviteError: null,

  delUserLoading: false,
  delUserSuccess: false,
  delUserError: null,

  userAttr: null,

  filter: {},

  uploadAvatarLoading: false,
  uploadAvatarSuccess: false,
  uploadAvatarError: null,
  addSuccess: false,
  addUserId: undefined,

  linkCode: null,
  linkLoading: false,
  linkSuccess: false,
  linkError: null,
};

export const reducer: Reducer<IInitialState & PersistPartial, TAppActions> = persistReducer(
  { storage, key: 'users', whitelist: ['user', 'authToken'] },
  (state = initialState, action: any) => {
    switch (action.type) {
      case CLEAR_FETCH: {
        return { ...state, loading: false, error: null, success: false };
      }

      case FETCH_REQUEST: {
        return {
          ...state,
          users: [],
          loading: true,
          error: null,
          success: false,
        };
      }

      case SET_USERS: {
        return {
          ...state,
          users: action.payload,
        };
      }

      case FETCH_SUCCESS: {
        return {
          ...state,
          page: action.payload.number,
          size: action.payload.size,
          total: action.payload.totalElements,
          users: action.payload,
          loading: false,
          success: true,
        };
      }

      case CLEAR_PAGINATION: {
        return {
          ...state,
          page: 0,
          size: 20,
        };
      }

      case FETCH_FAIL: {
        return { ...state, loading: false, error: action.payload };
      }

      case CLEAR_FETCH_BY_ID: {
        return {
          ...state,
          user: null,
          byIdLoading: false,
          byIdError: null,
          byIdSuccess: false,
        };
      }

      case FETCH_BY_ID_REQUEST: {
        return {
          ...state,
          user: null,
          byIdLoading: true,
          byIdError: null,
          byIdSuccess: false,
        };
      }

      case FETCH_BY_ID_SUCCESS: {

        console.log('action', action.payload);

        return { ...state, user: action.payload, byIdLoading: false, byIdSuccess: true };
      }

      case FETCH_BY_ID_FAIL: {
        return { ...state, byIdLoading: false, byIdError: action.payload };
      }

      case CLEAR_EDIT: {
        return {
          ...state,
          editLoading: false,
          editError: null,
          editSuccess: false,
          user: null,
        };
      }

      case CLEAR_ADD: {
        return {
          ...state,
          addLoading: false,
          addError: null,
          addSuccess: false,
          user: null,
        };
      }

      case ADD_REQUEST: {
        return { ...state, editLoading: true, editError: null, editSuccess: false };
      }

      case EDIT_REQUEST: {
        return {
          ...state,
          editLoading: true,
          editError: null,
          editSuccess: false,
          addSuccess: false,
          addUserId: undefined,
        };
      }

      case ADD_SUCCESS: {
        return {
          ...state,
          editLoading: false,
          editSuccess: true,
          addSuccess: true,
        };
      }

      case CLEAR_ADD_USER_ID: {
        return {
          ...state,
          addSuccess: false,
          addUserId: undefined,
        };
      }

      case EDIT_SUCCESS: {
        const payload = action.payload as IUser

        return {
          ...state,
          editLoading: false,
          editSuccess: true,
          // user: payload,
          // users: state.users?.content.map(item =>
          //   item.id === payload.id ? { ...item, ...payload } : item
          // )
        };
      }

      case EDIT_FAIL: {
        return { ...state, editLoading: false, editError: action.payload };
      }

      case CLEAR_SEND_INVITE: {
        return {
          ...state,
          sendInviteLoading: false,
          sendInviteError: null,
          sendInviteSuccess: false,
        };
      }

      case SEND_INVITE_REQUEST: {
        return {
          ...state,
          sendInviteLoading: true,
          sendInviteError: null,
          sendInviteSuccess: false,
        };
      }

      case SEND_INVITE_SUCCESS: {
        return { ...state, sendInviteLoading: false, sendInviteSuccess: true };
      }

      case SEND_INVITE_FAIL: {
        return { ...state, sendInviteLoading: false, sendInviteError: action.payload };
      }

      case CLEAR_DEL_USER: {
        return { ...state, delUserLoading: false, delUserError: null, delUserSuccess: false };
      }

      case DEL_USER_REQUEST: {
        return { ...state, delUserLoading: true, delUserError: null, delUserSuccess: false };
      }

      case DEL_USER_SUCCESS: {
        return { ...state, delUserLoading: false, delUserSuccess: true };
      }

      case DEL_USER_FAIL: {
        return { ...state, delUserLoading: false, delUserError: action.payload };
      }

      case SET_USERATTR: {
        return { ...state, userAttr: action.payload };
      }

      case SET_FILTER: {
        return {
          ...state,
          filter: {
            ...state.filter,
            ...action.payload,
          },
        };
      }

      case UPLOAD_AVATAR_REQUEST: {
        return {
          ...state,
          uploadAvatarLoading: true,
          uploadAvatarError: null,
          uploadAvatarSuccess: false,
        };
      }

      case UPLOAD_AVATAR_SUCCESS: {
        return {
          ...state,
          user: action.payload.data,
          uploadAvatarLoading: false,
          uploadAvatarError: null,
          uploadAvatarSuccess: true,
        };
      }

      case UPLOAD_AVATAR_FAIL: {
        return {
          ...state,
          uploadAvatarLoading: false,
          uploadAvatarError: action.payload,
          uploadAvatarSuccess: false,
        };
      }

      case CREATE_LINK_REQUEST: {
        return {
          ...state,
          linkCode: null,
          linkLoading: true,
          linkError: null,
          linkSuccess: false,
        };
      }

      case CREATE_LINK_SUCCESS: {
        return { 
          ...state, 
          linkCode: action.payload.code, 
          linkLoading: false, 
          linkSuccess: true 
        };
      }

      case CREATE_LINK_FAIL: {
        return { ...state, linkLoading: false, linkError: action.payload };
      }

      case CLEAR_LINK: {
        return { 
          ...state, 
          linkLoading: false, 
          linkError: null,
          linkSuccess: false,
          linkCode: null,
         };
      }
      
      default:
        return state;
    }
  }
);

export const actions = {
  // 
  clearFetch: () => createAction(CLEAR_FETCH),
  fetchRequest: (payload: TUserParamsSearch) => createAction(FETCH_REQUEST, payload),
  fetchSuccess: (payload: IServerResponse<IUserList>) => createAction(FETCH_SUCCESS, payload),
  fetchFail: (payload: string) => createAction(FETCH_FAIL, payload),

  clearFetchById: () => createAction(CLEAR_FETCH_BY_ID),
  fetchByIdRequest: (payload: string) => createAction(FETCH_BY_ID_REQUEST, payload),
  fetchByIdSuccess: (payload: IServerResponse<IUser> ) =>
    createAction(FETCH_BY_ID_SUCCESS, payload),
  fetchByIdFail: (payload: string) => createAction(FETCH_BY_ID_FAIL, payload),
  // 
  setUsers: (payload: IUser[]) => createAction(SET_USERS, payload),

  clearEdit: () => createAction(CLEAR_EDIT),
  clearAdd: () => createAction(CLEAR_ADD),
  addRequest: (payload: IUserAddProps) => createAction(ADD_REQUEST, payload),
  editRequest: (payload: { id: string; data: IUserEditProps, page?: number }) =>
    createAction(EDIT_REQUEST, payload),
  editSuccess: () => createAction(EDIT_SUCCESS),
  editFail: (payload: string) => createAction(EDIT_FAIL, payload),

  clearSendInvite: () => createAction(CLEAR_SEND_INVITE),
  sendInviteRequest: (payload: string) => createAction(SEND_INVITE_REQUEST, payload),
  sendInviteSuccess: () => createAction(SEND_INVITE_SUCCESS),
  sendInviteFail: (payload: string) => createAction(SEND_INVITE_FAIL, payload),

  // 
  clearDelUser: () => createAction(CLEAR_DEL_USER),
  delUserRequest: (payload: string) => createAction(DEL_USER_REQUEST, payload),
  delUserSuccess: () => createAction(DEL_USER_SUCCESS),
  delUserFail: (payload: string) => createAction(DEL_USER_FAIL, payload),

  setUserAttr: (payload: TUserAttr) => createAction(SET_USERATTR, payload),

  setFilter: (payload: any) => createAction(SET_FILTER, payload),

  uploadAvatarRequest: (payload: { photo: FormData; id: string }) =>
    createAction(UPLOAD_AVATAR_REQUEST, payload),
  uploadAvatarSuccess: (payload: IServerResponse<IUser>) =>
    createAction(UPLOAD_AVATAR_SUCCESS, payload),
  uploadAvatarFail: (payload: string) => createAction(UPLOAD_AVATAR_FAIL, payload),
  clearPagination: () => createAction(CLEAR_PAGINATION),
  addSuccess: () => createAction(ADD_SUCCESS),
  clearAddUserId: () => createAction(CLEAR_ADD_USER_ID),

  clearLink: () => createAction(CLEAR_LINK),
  createLinkRequest: (payload: string) => createAction(CREATE_LINK_REQUEST, payload),
  createLinkSuccess: (payload: string) => createAction(CREATE_LINK_SUCCESS, payload),
  createLinkFail: (payload: string) => createAction(CREATE_LINK_FAIL, payload),
};

export type TActions = ActionsUnion<typeof actions>;

function* fetchSaga({ payload }: { payload: TUserParamsSearch }) {
  try {
    const { data }: { data: IServerResponse<IUserList> } = yield call(() =>
      getUsersByRole(payload)
    );
    yield put(actions.fetchSuccess(data));
  } catch (e) {
    yield put(actions.fetchFail(getResponseMessage(e)));
  }
}

function* fetchByIdSaga({ payload }: { payload: string }) {
  try {
    const { data }: { data: IServerResponse<IUser> } = yield call(() => getUser(payload));

    yield put(actions.fetchByIdSuccess(data));
  } catch (e) {
    yield put(actions.fetchByIdFail(getResponseMessage(e)));
  }
}

function* addSaga({ payload }: { payload: IUserAddProps }) {
  try {
    const { data }: { data: string } = yield call(() => createUser(payload));
    if(data){
      yield put(
        actions.fetchRequest({
          page: 0, size: 20
        })
      );
    }
    yield put(actions.addSuccess());
  } catch (e) {
    yield put(actions.editFail(getResponseMessage(e)));
  }
}

function* editSaga({ payload }: { payload: { id: string; data: IUserEditProps, page?: number } }) {
  try {
    const { data }: { data: IServerResponse<IUser> } = yield call(() =>
      editUser(payload.id, payload.data)
    );
    if(data){
      yield put(
        actions.fetchRequest({
          page: payload.page || 0, size: 20
        })
      );
    }
    yield put(actions.editSuccess());
  } catch (e) {
    yield put(actions.editFail(getResponseMessage(e)));
  }
}

function* createLinkSaga({ payload }: { payload: string }) {
  try {
    const { data }: { data: string } = yield call(() =>
      createLink(payload)
    );

    yield put(actions.createLinkSuccess(data));
  } catch (e) {
    yield put(actions.editFail(getResponseMessage(e)));
  }
}

function* sendInviteSaga({ payload }: { payload: string }) {
  try {
    yield call(() => sendInvite(payload));
    yield put(actions.sendInviteSuccess());
  } catch (e) {
    yield put(actions.sendInviteFail(getResponseMessage(e)));
  }
}

function* delUserSaga({ payload }: { payload: string }) {
  try {
    yield call(() => deleteUser(payload));
    yield put(actions.delUserSuccess());
  } catch (e) {
    yield put(actions.delUserFail(getResponseMessage(e)));
  }
}

function* uploadAvatarSaga({ payload }: { payload: { photo: FormData; id: string } }) {
  try {
    const { data }: { data: IServerResponse<IUser> } = yield call(() =>
      uploadUserAvatar(payload)
    );
    yield put(actions.uploadAvatarSuccess(data));
  } catch (e) {
    yield put(actions.uploadAvatarFail(e?.response?.data?.message || 'Network error'));
  }
}

export function* saga() {
  yield takeLatest<ReturnType<typeof actions.fetchRequest>>(FETCH_REQUEST, fetchSaga);
  yield takeLatest<ReturnType<typeof actions.fetchByIdRequest>>(
    FETCH_BY_ID_REQUEST,
    fetchByIdSaga
  );
  yield takeLatest<ReturnType<typeof actions.addRequest>>(ADD_REQUEST, addSaga);
  yield takeLatest<ReturnType<typeof actions.editRequest>>(EDIT_REQUEST, editSaga);
  yield takeLatest<ReturnType<typeof actions.sendInviteRequest>>(
    SEND_INVITE_REQUEST,
    sendInviteSaga
  );
  yield takeLatest<ReturnType<typeof actions.delUserRequest>>(DEL_USER_REQUEST, delUserSaga);
  yield takeLatest<ReturnType<typeof actions.uploadAvatarRequest>>(
    UPLOAD_AVATAR_REQUEST,
    uploadAvatarSaga
  );
  yield takeLatest<ReturnType<typeof actions.createLinkRequest>>(
    CREATE_LINK_REQUEST,
    createLinkSaga
  );
}
